export default {"src":"/sitetest/_next/static/media/first_nav_icon04.086ea026.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};